import { FieldComponent } from "./chunk-GWGNVESG.js";
import { CheckableGroup_MoreButton_default } from "./chunk-LGNOJ3DG.js";
import { CheckableGroupContext } from "./chunk-YG26ROD3.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableGroup/CheckableGroup.tsx
import { useMemo, useState } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var CHECKABLE_GROUP_CLASSNAME_MAP = {
  direction: {
    vertical: "",
    horizontal: "pd:checkable-group--horizontal"
  }
};
var CheckableGroup = _a => {
  var _b = _a,
    {
      children,
      variant = "primary",
      direction = "vertical",
      name,
      label,
      disabled,
      className,
      maxItems = Infinity,
      moreButton = /* @__PURE__ */jsx(CheckableGroup_MoreButton_default, {})
    } = _b,
    rest = __objRest(_b, ["children", "variant", "direction", "name", "label", "disabled", "className", "maxItems", "moreButton"]);
  const [totalItems, setTotalItems] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const context = useMemo(() => ({
    name,
    variant,
    disabled,
    maxItems,
    moreButton,
    totalItems,
    setTotalItems,
    isExpanded,
    setIsExpanded
  }), [name, variant, disabled, maxItems, moreButton, totalItems, setTotalItems, isExpanded, setIsExpanded]);
  if (!children) {
    return null;
  }
  return /* @__PURE__ */jsx(CheckableGroupContext.Provider, {
    value: context,
    children: /* @__PURE__ */jsxs(FieldComponent, __spreadProps(__spreadValues({
      as: "fieldset",
      name: "group-".concat(name),
      label,
      disabled,
      className: clsx("pd:checkable-group", CHECKABLE_GROUP_CLASSNAME_MAP.direction[direction], className)
    }, rest), {
      children: [/* @__PURE__ */jsx("legend", {
        className: "pd:checkable-group__legend",
        children: /* @__PURE__ */jsx(FieldComponent.Label, {
          as: "span"
        })
      }), children, /* @__PURE__ */jsx(FieldComponent.ValidationMessage, {}), /* @__PURE__ */jsx(FieldComponent.Description, {})]
    }))
  });
};
var CheckableGroup_default = CheckableGroup;
export { CheckableGroup_default };